<template>
  <div class="content-card station-card">
    <a
      v-if="icon"
      :href="link"
      target="_blank"
      rel="noopener"
      class="station-icon-link"
    >
      <img :src="icon" :alt="title + ' logo'" class="station-icon" />
    </a>
    <div class="station-info">
      <h3>
        <a :href="link" target="_blank" rel="noopener" class="station-title-link">
          {{ title }}
        </a>
      </h3>
      <p>{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentCard',
  props: {
    title: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.station-card {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
}

.station-icon-link {
  flex-shrink: 0;
}

.station-icon {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-default);
  object-fit: cover;
  box-shadow: var(--shadow-card);
  transition: opacity var(--transition-default), transform var(--transition-fast);
}

.station-icon:hover {
  opacity: 0.85;
  transform: scale(1.04);
}

.station-info {
  flex: 1;
  min-width: 0;
}

.station-info h3 {
  margin: 0 0 0.5rem;
}

.station-title-link {
  color: var(--color-primary);
  text-decoration: none;
  font-size: var(--font-size-h3);
  font-weight: 600;
  transition: color var(--transition-default);
}

.station-title-link:hover {
  color: var(--color-primary-hover);
  text-decoration: underline;
}

.station-info p {
  margin: 0;
  font-size: var(--font-size-body-small);
  color: var(--color-light-gray);
  line-height: var(--line-height-relaxed);
}

@media (max-width: 480px) {
  .station-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .station-icon {
    width: 88px;
    height: 88px;
  }
}
</style>
